/* eslint-disable no-useless-escape */
'use client';

import { usePathname } from 'next/navigation';
import { useCallback } from 'react';
const routesBreadcrumbItems: DynamicRoutes = [{
  regex: /^\/pdp\/\d+\/?$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/pdp',
    title: 'همه طرح‌ها'
  }]
}, {
  regex: /^\/?crowdfunding\/[^\/]+\/[^\/]+\/[^\/]+\/?$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/crowdfunding-plan',
    title: 'همه طرح‌ها'
  }]
}, {
  regex: /^\/plans$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/plans',
    title: 'طرح‌های سرمایه‌گذاری'
  }]
}, {
  regex: /^\/crowdfunding-plan$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/crowdfunding-plan',
    title: 'طرح‌های سرمایه‌گذاری'
  }]
}, {
  // eslint-disable-next-line no-useless-escape
  regex: /^\/profile\/[^\/]+\/?$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/profile',
    title: 'پروفایل من'
  }]
}, {
  // eslint-disable-next-line no-useless-escape
  regex: /^\/dashboard\/[^\/]+\/?$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/dashboard',
    title: 'پروفایل من'
  }]
}, {
  regex: /^\/user-plans\/\d+\/?$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/user-plans',
    title: 'طرح‌های من'
  }]
}, {
  regex: /^\/user-crowdfunding-plan$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/user-crowdfunding-plan',
    title: 'طرح‌های من'
  }]
}, {
  regex: /^\/user-crowdfunding\/\d+\/?$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/user-crowdfunding-plan',
    title: 'طرح‌های من'
  }]
}, {
  regex: /^\/user-crowdfunding-plan$/,
  routes: [{
    route: '/',
    title: 'خانه'
  }, {
    route: '/user-crowdfunding-plan',
    title: 'طرح‌های من'
  }]
}];
export function useRoutes(): () => {
  title: string;
  route: string;
}[] {
  const pathname = usePathname();
  return useCallback(() => {
    for (let i = 0; i < routesBreadcrumbItems.length; i++) {
      if (routesBreadcrumbItems[i].regex.test(pathname)) {
        return routesBreadcrumbItems[i].routes;
      }
    }
    return [];
  }, [pathname]);
}
type DynamicRoutes = {
  regex: RegExp;
  routes: {
    title: string;
    route: string;
  }[];
}[];